"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTimeToHHMMString = void 0;
function transformTimeToHHMMString(date) {
    const dateToString = new Date(date);
    let hours = dateToString.getUTCHours().toString();
    if (hours.length === 1) {
        hours = `0${hours}`;
    }
    let minutes = dateToString.getUTCMinutes().toString();
    if (minutes.length === 1) {
        minutes = `0${minutes}`;
    }
    return `${hours}:${minutes}`;
}
exports.transformTimeToHHMMString = transformTimeToHHMMString;
//# sourceMappingURL=transformTimeToHHMMString.js.map